import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';

import { JobLevelTypes, PropsGetJobLevel } from 'components/types/company';
import styled from 'styled-components';
import { useOuterClick } from 'providers/OutsideClick';
import JobLevelModal from '../modal/index';
import getJobLevelColumns from './columnsJobLevel';

const CustomTableMod = styled.div`
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

function JobLevel(props: PropsGetJobLevel) {
  const {
    t,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const { keyJobLevel, listJobLevel } = useSelector((state: any) => ({
    listJobLevel: state?.organization?.list_job,
    keyJobLevel: state?.loading?.listKey?.jobLevel,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
          || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
    }
  });

  const handleEditClick = useCallback((val: JobLevelTypes) => {
    setDataEdit(val);
    setShowModal(true);
    setTypeForm('update');
  }, [setDataEdit]);

  const columnsJobLevel = useMemo(() => getJobLevelColumns({
    t,
    handleClickAction: handleEditClick,
  }), [handleEditClick]);

  return (
    <>
      {showModal && (
      <JobLevelModal
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        dataJobLevel={dataEdit}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="list_jobLevel"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyJobLevel ? <LoadingCustom /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('org.job_lvl.name')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(!showModal);
                    setTypeForm('create');
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columnsJobLevel}
                data={listJobLevel}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        ) }
      </div>
    </>
  );
}

export default JobLevel;
